import { useEffect } from 'react';
import { getMUICache, appendStyleSheet, getImageUrl, getImageSize, convertEpochTime, getImageId, fetchAnchorValue /*getImageId,  getListButtonIcon*/ } from '../../../common/utils';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// import WebStoriesOutlinedIcon from '@mui/icons-material/WebStoriesOutlined';
// const DEFAULT_PLACEHOLDER = "https://static.toiimg.com/photo/42706777.gif";
import "./WebStoriesListTwo.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  const { showDate,item,cardTextColor,cardBGColor, anchorLinksValue } = props;
  const { hl,imageid, pubInfo, upd, wu } = item;
  const cache = getMUICache();
  let styles = require("./WebStoriesListTwo.css");
  appendStyleSheet("WebStoriesListTwo", styles);

  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();
    useEffect(()=>{
        EagerLoadImages()
    },[]);

  // let imageSize = getImageSize(imageid);

  return (
    <CacheProvider value={cache}>
   
      <a className='ThemeTwoWebGridWrapSlide'  role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, (wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu)))} >
            <div className="ThemeTwoWebGridWrap">
              <div className="ThemeTwoWebGridImgWrap">
                {
                    getImageSize(imageid) && <picture>
                        {/* Add multiple source elements for different image sources */}
                        <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 214, 260, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />

                        <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 214, 260, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />

                        <img  alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                    </picture>
                }
              </div>
              <div className="ThemeTwoWebGridCarContentWrap" style={{backgroundColor:cardBGColor}}>
                <p className="webStroiesGridcardDiscription" style={{color:cardTextColor}}>{hl}</p>
                <p className="webStroiesDateTime">{showDate ? convertEpochTime(upd, 'updated', "DD MMM YYYY") : ""}</p>
              </div>
              <div className='ThemeTwoWebGridCarIconWrap'>
                      {/* <WebStoriesOutlinedIcon /> */}
                      <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.2381 4.14267C26.2381 3.37999 26.8564 2.76172 27.619 2.76172C28.3817 2.76172 29 3.37999 29 4.14267V23.476C29 24.2387 28.3817 24.857 27.619 24.857C26.8564 24.857 26.2381 24.2387 26.2381 23.476V4.14267Z" fill="white"/>
                            <path d="M0 4.14267C0 3.37999 0.618273 2.76172 1.38095 2.76172C2.14363 2.76172 2.7619 3.37999 2.7619 4.14267V23.476C2.7619 24.2387 2.14363 24.857 1.38095 24.857C0.618273 24.857 0 24.2387 0 23.476V4.14267Z" fill="white"/>
                            <mask id="path-2-inside-1_885_3513" fill="white">
                            <rect x="5.53125" width="17.9524" height="27.619" rx="2"/>
                            </mask>
                            <rect x="5.53125" width="17.9524" height="27.619" rx="2" stroke="white" stroke-width="5" mask="url(#path-2-inside-1_885_3513)"/>
                      </svg>
                    </div>
            </div>
          </a>
          
    </CacheProvider>
  )
}
export default Card;